import React, {
  createContext,
  useState,
  useEffect,
} from "react";

import api from "../api";
import Swal from "sweetalert2";

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [checkingUser, setCheckingUser] = useState(true);

  const fetchUser = async () => {
    try {
      const res = await api.get("auth/me", {
        withCredentials: true,
      });

      setUser(res.data);

      return res.data;
    } catch (err) {
      setUser(null);
      return null;
    } finally {
      setCheckingUser(false);
    }
  };

  useEffect(() => {
    fetchUser();
  }, []);

  const login = async (
    email,
    password,
    rememberMe = false
  ) => {
    try {
      const res = await api.post(
        "auth/login",
        {
          email,
          password,
          rememberMe,
        },
        {
          withCredentials: true,
        }
      );

      await fetchUser();

      Swal.fire({
        title: "Login Successful",
        text: res.data.message || "Welcome back!",
        icon: "success",
        confirmButtonText: "Continue",
        confirmButtonColor: "#993400",
      });

      return true;
    } catch (err) {
      Swal.fire({
        title: "Login Failed",
        text:
          err.response?.data?.message ||
          "Login failed",
        icon: "error",
      });

      return false;
    }
  };

  const logout = async () => {
    try {
      await api.post(
        "auth/logout",
        {},
        {
          withCredentials: true,
        }
      );

      setUser(null);

      Swal.fire({
        title: "Logged out",
        text:
          "You have been logged out successfully",
        icon: "success",
      });
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <UserContext.Provider
      value={{
        user,
        setUser,
        login,
        logout,
        fetchUser,
        checkingUser,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};